/**
 * Which markup the conversion actually divided by (CU-869ffwfam).
 *
 * The rail writes the conversion out as an equation so it can be
 * checked by hand, and the divisor has to be the one the engine used or
 * the equation is a lie. Two things can make the used percentage differ
 * from the measured one, and they need **opposite** divisors:
 *
 * | Case | Layer in the chain | `netBeforeCaps` | divisor |
 * |---|---|---|---|
 * | the rate card's cap bites (35 → 30) | yes, `markup_cap` | `target/1.35` | the **measured** |
 * | the measurement was below zero (−6.87 → 0) | none | `target` | the **used** |
 *
 * So the switch is `floored_at_zero`, never "is there a `used_pct`":
 * the cap sets `used_pct` too, and switching on it would print
 * `100 € ÷ 1.30 = 74.07 €` under a figure computed with 1.35.
 */

/** The number the rail divides by, or `null` when there is no markup. */
export function conversionFactor(measuredPct, markupBlock) {
	if (measuredPct == null) return null
	const pct = markupBlock?.floored_at_zero && markupBlock?.used_pct != null
		? Number(markupBlock.used_pct)
		: Number(measuredPct)
	return 1 + pct / 100
}

/** What the step says it removed, and — only when the measurement was
 *  impossible — why it did not use it. */
export function conversionNote(measuredPct, markupBlock) {
	const measured = Number(measuredPct)
	if (markupBlock?.floored_at_zero) {
		return `the market priced below our own net (${measured.toFixed(2)} %); a markup under zero is not a price to divide by, so the conversion used 0 %`
	}
	return `removing the ${measured.toFixed(2)} % broker markup measured above`
}
